import React from 'react';

class QuestionLink extends React.Component {
  render() {
    if (this.props.count) {
      return (
        <span className="badge badge-default badge-pill badge-link">
          {this.props.count}
        </span>
      );
    }
    return null;
  }
}

export default QuestionLink;
